const FULLY_VISIBLE_RATIO = 0.99; // 소수 픽셀·확대 상태에서는 완전히 보여도 0.99x로 보고된다
const DWELL_MS = 1000;

// element가 100% 보인 채 1초 이상 머물면 onImpression을 1회 호출한다.
// 탭이 숨겨지거나 1초 전에 가려지면 처음부터 다시 잰다. 반환값은 관찰 중지 함수.
export default (element, onImpression) => {
  if (!window.IntersectionObserver) return () => {};

  let timer = null;
  let sent = false;
  let fullyVisible = false;

  const cancel = () => {
    clearTimeout(timer);
    timer = null;
  };
  const tryStart = () => {
    if (
      sent ||
      timer ||
      !fullyVisible ||
      document.visibilityState !== 'visible'
    )
      return;
    timer = setTimeout(() => {
      sent = true;
      stop();
      onImpression();
    }, DWELL_MS);
  };
  const onVisibilityChange = () =>
    document.visibilityState === 'visible' ? tryStart() : cancel();

  const observer = new IntersectionObserver(
    entries => {
      entries.forEach(entry => {
        fullyVisible =
          entry.isIntersecting &&
          entry.intersectionRatio >= FULLY_VISIBLE_RATIO;
        if (fullyVisible) tryStart();
        else cancel();
      });
    },
    { threshold: [0, FULLY_VISIBLE_RATIO, 1] }
  );
  const stop = () => {
    cancel();
    observer.disconnect();
    document.removeEventListener('visibilitychange', onVisibilityChange);
  };

  document.addEventListener('visibilitychange', onVisibilityChange);
  observer.observe(element);
  return stop;
};
